export default "__VITE_ASSET__92d86b3f__"